// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"c412b77f","57":"e74eff85","84":"524b0cb3","111":"a46968b2","114":"725aea3e","339":"a78d1628","348":"2d2d7475","370":"463575c9","428":"a57a6b84","453":"04727aa3","468":"53a8be3a","643":"739ecdab","678":"a015f9c0","708":"3626c315","709":"bec983ab","893":"029c4a88"}[chunkId] + ".chunk.js";
};